import React from "react";
import { AlertTriangle } from "lucide-react";
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@/components/ui/hover-card";

interface NodeErrorDisplayProps {
  errors: string[];
}

export const NodeErrorDisplay: React.FC<NodeErrorDisplayProps> = ({
  errors,
}) => {
  if (!errors || errors.length === 0) {
    return null;
  }

  return (
    <HoverCard>
      <HoverCardTrigger asChild>
        <div className="absolute top-2 right-2 p-1 bg-red-100 rounded-full cursor-help">
          <AlertTriangle className="w-4 h-4 text-red-600" />
        </div>
      </HoverCardTrigger>
      <HoverCardContent className="w-80">
        <div className="space-y-2">
          <div className="flex items-center gap-2">
            <AlertTriangle className="w-4 h-4 text-red-600" />
            <span className="font-semibold text-sm">Validation Errors</span>
          </div>
          <div className="space-y-1">
            {errors.map((error, index) => (
              <div key={index} className="text-sm text-gray-600">
                • {error}
              </div>
            ))}
          </div>
        </div>
      </HoverCardContent>
    </HoverCard>
  );
};
